import { render, staticRenderFns } from "./ServiceCheckBox.vue?vue&type=template&id=7480c498&scoped=true&"
import script from "./ServiceCheckBox.vue?vue&type=script&lang=js&"
export * from "./ServiceCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCheckBox.vue?vue&type=style&index=0&id=7480c498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480c498",
  null
  
)

export default component.exports